(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'slider') return;

      this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
      if (this.slides.length <= 1) return;

      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.currentIndex < 0) this.currentIndex = 0;
      this.isAnimating = false;
      this.animationDuration = 450;

      this.prevButton = this.querySelector('.announcement-bar__button--prev');
      this.nextButton = this.querySelector('.announcement-bar__button--next');

      this.handlePrev = () => this.showSlide(this.currentIndex - 1);
      this.handleNext = () => this.showSlide(this.currentIndex + 1);

      if (this.prevButton) this.prevButton.addEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.handleNext);

      if (this.dataset.autoplay === 'true') {
        this.startAutoplay();
        this.addEventListener('mouseenter', this.stopAutoplay.bind(this));
        this.addEventListener('mouseleave', this.startAutoplay.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.handleNext);
      this.stopAutoplay();
    }

    showSlide(index) {
      if (this.isAnimating) return;

      const total = this.slides.length;
      const nextIndex = (index + total) % total;
      if (nextIndex === this.currentIndex) return;

      const currentSlide = this.slides[this.currentIndex];
      const nextSlide = this.slides[nextIndex];

      this.isAnimating = true;
      currentSlide.classList.add('is-leaving');
      currentSlide.classList.remove('is-active');
      nextSlide.classList.add('is-active');

      window.setTimeout(() => {
        currentSlide.classList.remove('is-leaving');
        this.currentIndex = nextIndex;
        this.isAnimating = false;
      }, this.animationDuration);
    }

    startAutoplay() {
      this.stopAutoplay();
      const interval = Number(this.dataset.interval) || 4000;
      this.autoplayTimer = window.setInterval(() => this.showSlide(this.currentIndex + 1), interval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('announcement-bar-section')) {
    customElements.define('announcement-bar-section', AnnouncementBarSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-image-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.shopify-section')?.querySelector('.background-image-text-section');

    if (!section || section.dataset.parallax !== 'true') return;

    const media = section.querySelector('[data-background-media]');
    if (!media) return;

    let ticking = false;

    const updateParallax = () => {
      const rect = section.getBoundingClientRect();
      const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      const shift = (progress - 0.5) * 28;
      const axis = getComputedStyle(section).getPropertyValue('--background-image-text-parallax-axis').trim();

      if (axis === 'horizontal') {
        media.style.transform = `translate3d(${shift}px, 0, 0) scale(1.06)`;
      } else {
        media.style.transform = `translate3d(0, ${shift}px, 0) scale(1.06)`;
      }
      ticking = false;
    };

    const requestUpdate = () => {
      if (window.innerWidth <= 749) {
        media.style.transform = 'none';
        return;
      }

      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    };

    updateParallax();
    document.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.shopify-section')?.querySelector('.hero-section');

    if (!section) return;

    const slides = Array.from(section.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(section.querySelectorAll('[data-hero-dot]'));
    const prevButton = section.querySelector('[data-hero-prev]');
    const nextButton = section.querySelector('[data-hero-next]');
    const autoplay = section.dataset.autoplay === 'true';
    const autoplaySpeed = Number(section.dataset.autoplaySpeed) || 5000;
    const parallaxEnabled = section.dataset.parallax === 'true';
    const mediaItems = Array.from(section.querySelectorAll('[data-hero-media]'));
    let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    let autoplayTimer = null;

    if (activeIndex < 0) activeIndex = 0;

    const updateSlides = (index) => {
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index;
        slide.classList.toggle('is-active', isActive);
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      activeIndex = index;
    };

    const goToSlide = (index) => {
      const normalizedIndex = (index + slides.length) % slides.length;
      updateSlides(normalizedIndex);
    };

    const startAutoplay = () => {
      if (!autoplay || slides.length < 2) return;
      window.clearInterval(autoplayTimer);
      autoplayTimer = window.setInterval(() => {
        goToSlide(activeIndex + 1);
      }, autoplaySpeed);
    };

    const stopAutoplay = () => {
      window.clearInterval(autoplayTimer);
    };

    prevButton?.addEventListener('click', () => {
      goToSlide(activeIndex - 1);
      startAutoplay();
    });

    nextButton?.addEventListener('click', () => {
      goToSlide(activeIndex + 1);
      startAutoplay();
    });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        goToSlide(index);
        startAutoplay();
      });
    });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    if (parallaxEnabled) {
      let ticking = false;

      const updateParallax = () => {
        const rect = section.getBoundingClientRect();
        const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        const translateY = (progress - 0.5) * 40;

        mediaItems.forEach((media) => {
          media.style.transform = `translate3d(0, ${translateY}px, 0) scale(1.08)`;
        });

        ticking = false;
      };

      const requestParallaxUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateParallax);
      };

      updateParallax();
      document.addEventListener('scroll', requestParallaxUpdate, { passive: true });
      window.addEventListener('resize', requestParallaxUpdate);
    }

    updateSlides(activeIndex);
    startAutoplay();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.shopify-section');
    if (!section) return;

    const player = section.querySelector('[data-video-id]');
    if (!player) return;

    const videoId = player.dataset.videoId;
    const provider = player.dataset.videoProvider;
    const autoplay = player.dataset.autoplay === 'true';
    const loop = player.dataset.loop === 'true';
    const muted = player.dataset.muted === 'true';
    const controls = player.dataset.controls === 'true';
    const embedEl = player.querySelector('[data-video-embed]');
    const coverBtn = player.querySelector('[data-video-play]');

    if (!videoId || !provider || !embedEl) return;

    const buildIframe = () => {
      const iframe = document.createElement('iframe');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');

      if (provider === 'youtube') {
        const params = new URLSearchParams({
          autoplay: '1',
          mute: muted || autoplay ? '1' : '0',
          loop: loop ? '1' : '0',
          playlist: loop ? videoId : '',
          controls: controls ? '1' : '0',
          rel: '0',
        });
        iframe.src = `https://www.youtube.com/embed/${videoId}?${params}`;
      } else if (provider === 'vimeo') {
        const params = new URLSearchParams({
          autoplay: '1',
          muted: muted || autoplay ? '1' : '0',
          loop: loop ? '1' : '0',
          controls: controls ? '1' : '0',
        });
        iframe.src = `https://player.vimeo.com/video/${videoId}?${params}`;
      }

      embedEl.appendChild(iframe);
      player.classList.add('video-section__player--playing');
    };

    if (autoplay && !coverBtn) {
      buildIframe();
    }

    coverBtn?.addEventListener('click', buildIframe);
  })();

  } catch(e) { console.error(e); }
})();
})();
